import React from 'react'
import styles from './SettingsDropDown.module.css'
import { DropdownButton, Dropdown } from 'react-bootstrap'
import {useTranslation} from "react-i18next";

const SettingsDropDown = (props) => {//props=[nowSelected,setSettings,settingType,settingName,items,label]
    //translations
    const t = useTranslation('common').t;
    let addForTranslation=''
    if(props.label==='openOnInquirieType'){
        addForTranslation='openOnInquirieTypeItems.'
    }
    else if(props.label==='autoDial'){
        addForTranslation='autoDialIItems.'
    }
    else if(props.label==='incomingCall_enable' || props.label==='incomingCall_onAnswer' || props.label==='isCallBackEnable' || props.label==='addCallBacksWhenDialerOpen'){
        addForTranslation='incomingCall_enable_items.'
    }
    
    let dropDownListItems=undefined
    if(props.items && props.settingType && props.settingName){
        dropDownListItems=props.items.map((item,i)=><Dropdown.Item key={i} onClick={() => props.setSettings(props.settingType, props.settingName, item)} className={styles.specificSettingsDropDownItem}>{t(addForTranslation+item)}</Dropdown.Item>)
    }
    return (
        <div className={styles.someSettingDiv}>
            <span className={styles.specificSettingsText}>{t(props.label)} </span>
            <DropdownButton className={styles.specificSettingsDropDown} variant='secondary' title={t(addForTranslation+props.nowSelected)}>
                {dropDownListItems}
            </DropdownButton>
        </div>
    )
}

export default SettingsDropDown